<template>
    <div class="input-outer-wrapper">
        <div class="editor-label-row flex justify-between items-center w-full">
            <span class="text-sm font-Inter-Bold text-grey-900 inline-flex input-label">{{ label }}</span>
            <transition name="slide">
                <button
                    v-if="clearLabel && value"
                    type="button"
                    class="hidden lg:flex rounded-full items-center justify-center p-[0.9rem] pl-3 bg-black text-white transition opacity-80 hover:opacity-100 h-4"
                    @click="$emit('clear')"
                >
                    <i class="ri-close-line text-base mr-1"></i>
                    <span class="font-Inter-Semibold text-xs block">{{ clearLabel }}</span>
                </button>
            </transition>
        </div>
        <!-- cards on desktop, a dropdown in the mobile row -->
        <fieldset class="hidden lg:grid grid-cols-2 gap-5">
            <div v-for="option in options" :key="`${name}-${option.id}`">
                <input
                    :id="`${name}-${option.id}`"
                    :checked="option.id === value"
                    type="radio"
                    :value="option.id"
                    :name="name"
                    class="hidden lg:block editor-radio-input"
                    @change="$emit('input', option.id)"
                />
                <label
                    :for="`${name}-${option.id}`"
                    class="flex justify-center flex-col items-center p-3 border border-black border-opacity-20 hover:border-opacity-60 transition cursor-pointer h-full rounded-lg"
                >
                    <img
                        :src="src(option)"
                        :alt="optionName(option)"
                        class="object-contain min-h-[7rem] min-w-[7rem] max-h-28 max-w-28"
                    />
                    <div class="flex items-center gap-x-2 flex-col justify-center">
                        <span class="w-4 h-4 min-w-4 min-h-4 rounded-full border border-black block marker mb-2"></span>
                        <span class="block font-Inter-Semibold text-sm text-center whitespace-nowrap">{{
                            optionName(option)
                        }}</span>
                    </div>
                </label>
            </div>
        </fieldset>
        <IconSelect
            class="lg:hidden"
            :value="value"
            :options="options"
            :src="src"
            :placeholder="placeholder"
            :append-to="appendTo"
            v-on="$listeners"
        />
    </div>
</template>

<script>
import IconSelect from '@/components/Editor/Shared/IconSelect.vue';

export default {
    name: 'CardPicker',
    components: { IconSelect },
    props: {
        value: {
            type: Number,
            default: null,
        },
        options: {
            type: Array,
            required: true,
        },
        // radio group name, also prefixes the input ids
        name: {
            type: String,
            required: true,
        },
        label: {
            type: String,
            required: true,
        },
        src: {
            type: Function,
            required: true,
        },
        placeholder: {
            type: String,
            default: null,
        },
        // shows a button that emits `clear` while an option is picked
        clearLabel: {
            type: String,
            default: null,
        },
        appendTo: {
            type: [String, Object],
            default: null,
        },
    },
    emits: ['input', 'clear', 'show', 'hide'],
    methods: {
        // option lists keep `name` (saved with orders) and add `labelKey` for display
        optionName(option) {
            return option.labelKey ? this.$t(option.labelKey) : option.name;
        },
    },
};
</script>
